class AutoTabs {
	constructor(groupNode) {
		this.tablistNode = groupNode;

		this.tabs = [];

		this.firstTab = null;
		this.lastTab = null;
		this.isTabSelect = ( this.tablistNode.tagName.toLowerCase() === 'select' );

		this.tabs = this.isTabSelect ? this.tablistNode.querySelectorAll('option') : this.tablistNode.querySelectorAll('[role=tab]');
		this.tabpanels = [];

		this.tabs.forEach((tab) => {
			const tabpanel = this.isTabSelect ? document.getElementById(tab.getAttribute('value')) : document.getElementById(tab.getAttribute('aria-controls'));

			if ( !this.isTabSelect ) {
				tab.tabIndex = -1;
				tab.setAttribute('aria-selected', 'false');
			}

			this.tabpanels.push(tabpanel);

			if ( this.isTabSelect ) {
				this.tablistNode.addEventListener('change', this.onChange.bind(this));
			}
			else {
				tab.addEventListener('keydown', this.onKeydown.bind(this));
				tab.addEventListener('click', this.onClick.bind(this));
			}

			if ( !this.firstTab ) {
				this.firstTab = tab;
			}
			this.lastTab = tab;
		});

		const defaultTabRef = this.tablistNode.dataset?.default || this.firstTab.dataset.ref;
		this.defaultTab = this.tablistNode.querySelector(`.tab-btn[data-ref="${defaultTabRef}"]`) || this.firstTab;

		this.setSelectedTab(this.defaultTab, false);
	}

	setSelectedTab(currentTab, setFocus) {
		if (typeof setFocus !== 'boolean') {
			setFocus = true;
		}
		this.tabs.forEach((tab, i) => {
			if (currentTab === tab) {

				if ( !this.isTabSelect ) {
					tab.setAttribute('aria-selected', 'true');
					tab.removeAttribute('tabindex');
					if ( setFocus ) {
						tab.focus();
					}
				}

				this.tabpanels[i].classList.add('active');
			}
			else {
				if ( !this.isTabSelect ) {
					tab.setAttribute('aria-selected', 'false');
					tab.tabIndex = -1;
				}

				this.tabpanels[i].classList.remove('active');
			}
		});
	}

	setSelectedToPreviousTab(currentTab) {
		let index;
		if (currentTab === this.firstTab) {
			this.setSelectedTab(this.lastTab);
		}
		else {
			index = this.tabs.indexOf(currentTab);
			this.setSelectedTab(this.tabs[index - 1]);
		}
	}

	setSelectedToNextTab(currentTab) {
		let index;
		if (currentTab === this.lastTab) {
			this.setSelectedTab(this.firstTab);
		}
		else {
			index = this.tabs.indexOf(currentTab);
			this.setSelectedTab(this.tabs[index + 1]);
		}
	}

	/* EVENT HANDLERS */

	onKeydown(event) {
		let tgt = event.currentTarget,
			flag = false;

		switch (event.key) {
			case 'ArrowLeft':
				this.setSelectedToPreviousTab(tgt);
				flag = true;
				break;

			case 'ArrowRight':
				this.setSelectedToNextTab(tgt);
				flag = true;
				break;

			case 'Home':
				this.setSelectedTab(this.firstTab);
				flag = true;
				break;

			case 'End':
				this.setSelectedTab(this.lastTab);
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	onClick(event) {
		this.setSelectedTab(event.currentTarget);
	}

	onChange(event) {
		this.setSelectedTab(event.currentTarget.querySelector(`option[value="${event.currentTarget.value}"]`));
	}
}
